import { getRootUrl } from './getRootUrl';
export function getPath(subpath) {
  return `${getRootUrl()}/${subpath}`;
}
export const getCurrentLocation = () => {
  return window.location.pathname;
};